var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Connector } from '@web3-react/types';
function parseChainId(chainId) {
    return Number.parseInt(chainId, 16);
}
export class WalletLink extends Connector {
    constructor(actions, options, connectEagerly = true) {
        super(actions);
        this.connectListener = ({ chainId }) => {
            this.actions.update({ chainId: parseChainId(chainId) });
        };
        this.disconnectListener = (error) => {
            this.actions.reportError(error);
        };
        this.chainChangedListener = (chainId) => {
            this.actions.update({ chainId: parseChainId(chainId) });
        };
        this.accountsChangedListener = (accounts) => {
            this.actions.update({ accounts });
        };
        this.options = options;
        if (connectEagerly) {
            this.eagerConnection = this.initialize(true);
        }
    }
    initialize(connectEagerly) {
        return __awaiter(this, void 0, void 0, function* () {
            let cancelActivation;
            if (connectEagerly) {
                cancelActivation = this.actions.startActivation();
            }
            const _a = this.options, { url } = _a, options = __rest(_a, ["url"]);
            return import('walletlink').then((m) => {
                if (!this.walletLink) {
                    this.walletLink = new m.WalletLink(options);
                }
                this.provider = this.walletLink.makeWeb3Provider(url);
                this.provider.on('connect', this.connectListener);
                this.provider.on('disconnect', this.disconnectListener);
                this.provider.on('chainChanged', this.chainChangedListener);
                this.provider.on('accountsChanged', this.accountsChangedListener);
                if (connectEagerly) {
                    return Promise.all([
                        this.provider.request({ method: 'eth_chainId' }),
                        this.provider.request({ method: 'eth_accounts' }),
                    ])
                        .then(([chainId, accounts]) => {
                        if (accounts === null || accounts === void 0 ? void 0 : accounts.length) {
                            this.actions.update({ chainId: parseChainId(chainId), accounts });
                        }
                        else {
                            throw new Error('No accounts returned');
                        }
                    })
                        .catch((error) => {
                        console.debug('Could not connect eagerly', error);
                        cancelActivation();
                    });
                }
            });
        });
    }
    activate() {
        return __awaiter(this, void 0, void 0, function* () {
            this.actions.startActivation();
            if (!this.eagerConnection) {
                this.eagerConnection = this.initialize(false);
            }
            yield this.eagerConnection;
            return Promise.all([
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                this.provider.request({ method: 'eth_chainId' }),
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                this.provider.request({ method: 'eth_requestAccounts' }),
            ])
                .then(([chainId, accounts]) => {
                this.actions.update({ chainId: parseChainId(chainId), accounts });
            })
                .catch((error) => {
                this.actions.reportError(error);
            });
        });
    }
    deactivate() {
        if (this.provider) {
            this.provider.off('connect', this.disconnectListener);
            this.provider.off('disconnect', this.disconnectListener);
            this.provider.off('chainChanged', this.chainChangedListener);
            this.provider.off('accountsChanged', this.accountsChangedListener);
            this.provider = undefined;
            this.eagerConnection = undefined;
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            this.walletLink.disconnect();
        }
    }
}
